export default {"src":"/login-app/[GIT_HASH]/_next/static/media/op_selector.475125e9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};